import { render, staticRenderFns } from "./LockAct.vue?vue&type=template&id=56082318&"
import script from "./LockAct.vue?vue&type=script&lang=js&"
export * from "./LockAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports